import { Container } from '@grupoboticario/flora-react';
import { Root, Trigger, Portal, Content } from '@radix-ui/react-hover-card';
import { user, Utilities } from 'core';
import { selectors as userSelectors } from 'core/use-cases/user';
import ClickAwayListener from 'react-click-away-listener';
import { HeaderSearch as HeaderSearchComponent } from 'ui/components';
import { FloraProvider } from 'ui/containers/ProviderComposer';

import { HeaderSearchResult } from '../HeaderSearchResult';
import { useHeaderSearch } from './hooks/useHeaderSearch';
import HeaderSearchInput from '../HeaderSearchInput/HeaderSearchInput';

export const HeaderSearch = () => {
  const {
    searchValue,
    handleChange,
    handleClearSearch,
    handleFocus,
    handleSearchClick,
    focus,
    statusPreview,
    handleFocusOverlay,
  } = useHeaderSearch();

  const {
    data: { isBlocked },
  } = user.hooks.useUser();

  if (isBlocked) {
    return null;
  }

  return (
    <ClickAwayListener onClickAway={handleFocusOverlay}>
      <HeaderSearchComponent.Wrapper>
        <Root open={focus && statusPreview !== Utilities.STATUS.IDLE} openDelay={0} closeDelay={0}>
          <Trigger asChild>
            <Container
              css={{
                paddingInlineStart: '0',
                paddingInlineEnd: '0',
              }}
              as="li"
            >
              <HeaderSearchInput
                handleChange={handleChange}
                handleClear={handleClearSearch}
                onSearchClick={handleSearchClick}
                onFocus={handleFocus}
                searchValue={searchValue}
                placeholder="Busque produtos por nome ou código"
              />
            </Container>
          </Trigger>
          <Portal>
            <Content
              style={{
                width: 'var(--radix-hover-card-trigger-width)',
                maxHeight: 'var(--radix-hover-card-content-available-height)',
              }}
              asChild
              sticky="always"
              sideOffset={0}
            >
              <Container size="large">
                <FloraProvider>
                  <HeaderSearchResult
                    query={searchValue}
                    focus={focus}
                    handleClearSearch={handleClearSearch}
                  />
                </FloraProvider>
              </Container>
            </Content>
          </Portal>
        </Root>
      </HeaderSearchComponent.Wrapper>
    </ClickAwayListener>
  );
};
